import { useMutation, useQueryClient } from '@tanstack/react-query';
import { bffApiClient } from '@api/bff/client';
import { workOrderKeys } from '@api/enterprise/workorder/constants';
import type { EquipmentSummary } from '@api/bff/equipment/useEquipment';

type AddWorkOrderEquipmentParams = {
  jobNumber: string;
  equipment: EquipmentSummary;
  relatedEventType?: string;
};

export type AddedWorkOrderDetail = {
  id?: string | null;
  sequenceNumber?: number | null;
  relatedEventType?: string | null;
};

export const useAddWorkOrderEquipment = () => {
  const queryClient = useQueryClient();

  return useMutation<AddedWorkOrderDetail, Error, AddWorkOrderEquipmentParams>({
    mutationFn: async ({
      jobNumber,
      equipment,
      relatedEventType = 'Calibration'
    }: AddWorkOrderEquipmentParams) => {
      const response = await bffApiClient.post<AddedWorkOrderDetail>(
        `/api/work-orders/${encodeURIComponent(jobNumber)}/details`,
        {
          relatedEventType,
          companyName: equipment.companyName,
          id: equipment.id,
          description: equipment.description,
          submittedManufacturer: equipment.manufacturer,
          submittedModelNumber: equipment.modelNumber,
          submittedAssetDescription: equipment.description,
          relatedEventDescrip: relatedEventType
        }
      );

      if (import.meta.env.DEV) {
        console.debug(
          '[useAddWorkOrderEquipment] POST /details',
          response.status,
          response.data
        );
      }

      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: workOrderKeys.all() });
    }
  });
};
